<div class="table-container">
  <p-table [value]="batches" [paginator]="true" [rows]="5">
    <ng-template pTemplate="header">
      <tr>
        <th>Lote</th>
        <th>Status</th>
        <th>Vendas</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-batch let-rowIndex="rowIndex">
      <tr>
        <td>{{ batch.batch_title }}</td>
        <td>{{ getStatus(batch) }}</td>
        <td>{{ batchSoldTickets(rowIndex) }}/{{ batchTotalTickets(rowIndex) }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>
